import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from "react-i18next";

const FamilyLegalServices = () => {
  const { t } = useTranslation();

  const serviceSections = [
    {
      key: "uncontestedDivorce",
      title: t("familyLegalServices.sections.uncontestedDivorce.title"),
      items: [
        t("familyLegalServices.sections.uncontestedDivorce.item1"),
        t("familyLegalServices.sections.uncontestedDivorce.item2"),
      ],
      description: t("familyLegalServices.sections.uncontestedDivorce.description"),
    },
    {
      key: "childSupportChange",
      title: t("familyLegalServices.sections.childSupportChange.title"),
      items: [
        t("familyLegalServices.sections.childSupportChange.item1"),
        t("familyLegalServices.sections.childSupportChange.item2"),
      ],
      description: t("familyLegalServices.sections.childSupportChange.description"),
    },
    {
      key: "supportEnforcement",
      title: t("familyLegalServices.sections.supportEnforcement.title"),
      items: [
        t("familyLegalServices.sections.supportEnforcement.item1"),
        t("familyLegalServices.sections.supportEnforcement.item2"),
      ],
      description: t("familyLegalServices.sections.supportEnforcement.description"),
    },
    {
      key: "domesticContracts",
      title: t("familyLegalServices.sections.domesticContracts.title"),
      items: [
        t("familyLegalServices.sections.domesticContracts.item1"),
        t("familyLegalServices.sections.domesticContracts.item2"),
      ],
      note: t("familyLegalServices.sections.domesticContracts.note"),
    },
    {
      key: "nameChange",
      title: t("familyLegalServices.sections.nameChange.title"),
      items: [
        t("familyLegalServices.sections.nameChange.item1"),
        t("familyLegalServices.sections.nameChange.item2"),
      ],
    },
    {
      key: "processNavigation",
      title: t("familyLegalServices.sections.processNavigation.title"),
      items: [
        t("familyLegalServices.sections.processNavigation.item1"),
        t("familyLegalServices.sections.processNavigation.item2"),
      ],
    },
  ];

  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Family Legal Services Provider (FLSP) | Min & Ying Legal Services
            Professional Corporation
          </title>
          <meta
            name="description"
            content="Family Legal Services Provider (FLSP) offering uncontested divorce, child support motions to change, support enforcement, domestic contracts filing, name changes, and process navigation across Ontario."
          />
        </Helmet>

        <HeroSlider />

        <section className="container py-5 px-3">
          <div className="row g-4 align-items-center">
            <div className="col-lg-7">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4 p-lg-5">
                  <h1
                    className="guide-text mb-3"
                    style={{ fontSize: "1.8rem", lineHeight: "2.4rem" }}
                  >
                    {t("familyLegalServices.title")}
                  </h1>
                  <p className="fw-bold mb-3">
                    {t("familyLegalServices.subtitle")}
                  </p>
                  <p>{t("familyLegalServices.locations")}</p>
                  <p>{t("familyLegalServices.intro1")}</p>
                  <p className="mb-0">{t("familyLegalServices.intro2")}</p>
                  <div
                    className="text-center fst-italic pt-4"
                    style={{ color: "#053661", fontSize: "1.2rem" }}
                  >
                    {`— ${t("familyLegalServices.tagline")} —`}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <img
                src="/assets/family-law.webp"
                className="img-fluid rounded-3 shadow-sm"
                alt={t("familyLegalServices.title")}
                style={{ width: "100%", maxHeight: "460px", objectFit: "cover" }}
              />
            </div>
          </div>
        </section>

        <section className="container pb-5 px-3">
          <h5 className="guide-text mb-4">
            {t("familyLegalServices.servicesTitle")}
          </h5>
          <div className="row g-4">
            {serviceSections.map((section) => (
              <div className="col-lg-6" key={section.key}>
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body p-4">
                    <h6 className="guide-text-no-border mb-3">{section.title}</h6>
                    <ul className="mb-0" style={{ paddingLeft: "1.3rem" }}>
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                    {section.description ? (
                      <p className="mt-3 mb-0">{section.description}</p>
                    ) : null}
                    {section.note ? (
                      <p
                        className="mt-3 mb-0 fst-italic"
                        style={{ color: "#6b5b35" }}
                      >
                        {section.note}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="container pb-5 px-3">
          <div className="card border-0 shadow-sm">
            <div
              className="card-body p-4 p-lg-5"
              style={{ backgroundColor: "#f8f6f1" }}
            >
              <h5 className="guide-text mb-4">
                {t("familyLegalServices.scopeTitle")}
              </h5>
              <p>{t("familyLegalServices.scopeText1")}</p>
              <p className="mb-0">{t("familyLegalServices.scopeText2")}</p>
            </div>
          </div>
        </section>

        <section className="container pb-5 px-3">
          <div className="card border-0 shadow-sm text-center">
            <div className="card-body p-4 p-lg-5">
              <h5 className="mb-3">
                {t("familyLegalServices.consultationTitle")}
              </h5>
              <p className="mb-4">{t("familyLegalServices.consultationText")}</p>
              <Link to="/contact-us" className="btn btn-outline-secondary px-4">
                {t("familyLegalServices.consultationButton")}
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FamilyLegalServices;
